export enum StyleEventCard {
  'square',
  'line',
}